module.exports = __webpack_public_path__ + "img/inbox.846703ed.svg";